import React from "react";
import { Row, Col, Input, Label, FormFeedback } from "reactstrap";

const FeaturesForm = ({ validation }: { validation: any }) => {
  return (
    <Row className="g-4">

      {/* Policy Term (Text) */}
      <Col md={6}>
        <Label className="fw-bold mb-1">Policy Term</Label>
        <Input
          type="text"                // text input
          name="policy_term"
          placeholder="Type here.."
            onBlur={validation.handleBlur}      // REQUIRED

          value={validation.values.policy_term}
          onChange={validation.handleChange}
          invalid={!!(validation.touched.policy_term && validation.errors.policy_term)}
        />
        <FormFeedback>{validation.errors.policy_term}</FormFeedback>
      </Col>

      {/* Premium Paying Term (Text) */}
      <Col md={6}>
        <Label className="fw-bold mb-1">Premium Paying Term</Label>
        <Input
          type="text"
          name="premium_term"
          placeholder="Type here.."
          value={validation.values.premium_term}
          onChange={validation.handleChange}
          invalid={!!(validation.touched.premium_term && validation.errors.premium_term)}
        />
        <FormFeedback>{validation.errors.premium_term}</FormFeedback>
      </Col>

      {/* Minimum Sum Assured (Number) */}
      <Col md={6}>
        <Label className="fw-bold mb-1">Minimum Sum Assured</Label>
        <Input
          type="text"             
          name="minimum_sum_assured"
          placeholder="500000"
          value={validation.values.minimum_sum_assured}
          onChange={(e) => {
            validation.handleChange(e);
            // Untouch maximum field to prevent showing both errors together while editing
            if (validation.touched.maximum_sum_assured) {
              validation.setFieldTouched("maximum_sum_assured", false, false);
            }
          }}
          onBlur={(e) => {
            validation.handleBlur(e);
            // Use setTimeout to ensure validation completes before checking errors
            // This ensures we show only one error at a time
            setTimeout(() => {
              if (!validation.errors.minimum_sum_assured && validation.values.maximum_sum_assured) {
                validation.setFieldTouched("maximum_sum_assured", true, false);
              }
            }, 0);
          }}
          invalid={!!(validation.touched.minimum_sum_assured && validation.errors.minimum_sum_assured)}
        />
        <FormFeedback>{validation.errors.minimum_sum_assured}</FormFeedback>
      </Col>

      {/* Maximum Sum Assured (Number) */}
      <Col md={6}>
        <Label className="fw-bold mb-1">Maximum Sum Assured</Label>
        <Input
          type="text"             
          name="maximum_sum_assured"
          placeholder="5000000"
          value={validation.values.maximum_sum_assured}
          onChange={(e) => {
            validation.handleChange(e);
            // Untouch minimum field to prevent showing both errors together while editing
            if (validation.touched.minimum_sum_assured) {
              validation.setFieldTouched("minimum_sum_assured", false, false);
            }
          }}
          onBlur={(e) => {
            validation.handleBlur(e);
            // Use setTimeout to ensure validation completes before checking errors
            // This ensures we show only one error at a time
            setTimeout(() => {
              if (!validation.errors.maximum_sum_assured && validation.values.minimum_sum_assured) {
                validation.setFieldTouched("minimum_sum_assured", true, false);
              }
            }, 0);
          }}
          invalid={!!(validation.touched.maximum_sum_assured && validation.errors.maximum_sum_assured)}
        />
      <FormFeedback>{validation.errors.maximum_sum_assured}</FormFeedback>
      </Col>

      {/* Maturity Bonus Benefit (Text) */}
      <Col md={6}>
        <Label className="fw-bold mb-1">Maturity Bonus Benefit</Label>
        <Input
          type="text"
          name="maturity_bonus_benefit"
          placeholder="Type here.."
          value={validation.values.maturity_bonus_benefit}
          onChange={validation.handleChange}
          invalid={!!(validation.touched.maturity_bonus_benefit && validation.errors.maturity_bonus_benefit)}
        />
        <FormFeedback>{validation.errors.maturity_bonus_benefit}</FormFeedback>
      </Col>

      <Col md={6}>
        <Label className="fw-bold mb-1">Death Benefit</Label>
        <Input
          type="text"
          name="death_benefit"
          placeholder="Type here.."
          value={validation.values.death_benefit}
          onChange={validation.handleChange}
          invalid={!!(validation.touched.death_benefit && validation.errors.death_benefit)}
        />
        <FormFeedback>{validation.errors.death_benefit}</FormFeedback>
      </Col>

    <Col md={6}>
      <Label className="fw-bold mb-1">Loan Facility</Label>
      <Input
        type="text"
        name="loan_facility"
        placeholder="Type here..."
        value={validation.values.loan_facility}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        invalid={!!(validation.touched.loan_facility && validation.errors.loan_facility)}
      />
      <FormFeedback>{validation.errors.loan_facility}</FormFeedback>
    </Col>

      <Col md={6}>
        <Label className="fw-bold mb-1">Surrender Value</Label>
        <Input
          type="text"
          name="surrendar_value"
          placeholder="Type here.."
          value={validation.values.surrendar_value}
          onChange={validation.handleChange}
          invalid={!!(validation.touched.surrendar_value && validation.errors.surrendar_value)}
        />
        <FormFeedback>{validation.errors.surrendar_value}</FormFeedback>
      </Col>

    </Row>
  );
};

export default FeaturesForm;
